import { FC } from "react";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate";
import { useTranslator } from "@/i18n/useTranslator";

import { DsButton, DsIcon, DsText } from "../components/ui";
import { classNames } from "../utils/classNames";

export type DriverFlowBottomButtonPropsType = {
  onNextButtonClick: () => void;
  isNextButtonLoading?: boolean;
  nextButtonTitle?: I18nKeyType;
  isNextButtonDisabled?: boolean;
  previousButtonTitle?: I18nKeyType;
  previousButtonTitlei18nOptions?: object;
  onPreviousButtonClick?: () => void;
  isPreviousButtonLoading?: boolean;
  shouldShowPreviousButtonIcon?: boolean;
};

const DriverFlowBottomButton: FC<DriverFlowBottomButtonPropsType> = ({
  onNextButtonClick,
  isNextButtonLoading,
  nextButtonTitle = "next",
  isNextButtonDisabled,
  previousButtonTitle,
  previousButtonTitlei18nOptions,
  onPreviousButtonClick,
  isPreviousButtonLoading,
  shouldShowPreviousButtonIcon = true,
}) => {
  const { t } = useTranslator();

  const hasLeftButton = Boolean(onPreviousButtonClick);

  const parsedPreviousButtonTitle = useTranslate(
    previousButtonTitle,
    previousButtonTitlei18nOptions,
  );

  return (
    <div
      className={classNames(
        "sticky bottom-0 pb-4 w-full bg-gray-100 inline-flex gap-2",
        hasLeftButton
          ? "items-center justify-between"
          : "items-end justify-end",
      )}>
      {hasLeftButton && (
        <div className="w-1/2 ">
          <DsButton
            variant="white"
            className="mt-4 bg-white w-full"
            isLoading={isPreviousButtonLoading}
            onClick={onPreviousButtonClick}>
            {shouldShowPreviousButtonIcon && (
              <div>
                <DsIcon icon="ArrowLeft" className="mr-2" />
              </div>
            )}
            {parsedPreviousButtonTitle && (
              <DsText variant="button" className="truncate">
                {parsedPreviousButtonTitle}
              </DsText>
            )}
          </DsButton>
        </div>
      )}
      <div className={classNames(hasLeftButton && "w-1/2")}>
        <DsButton
          className={classNames("mt-4", hasLeftButton && "w-full")}
          onClick={onNextButtonClick}
          isLoading={isNextButtonLoading}
          disabled={isNextButtonDisabled}>
          <DsText variant="button" className="truncate">
            {t(nextButtonTitle)}
          </DsText>
          <div>
            <DsIcon icon="ArrowRight" className="ml-2" />
          </div>
        </DsButton>
      </div>
    </div>
  );
};

export { DriverFlowBottomButton };
